import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import toast from "react-hot-toast";

function EyeIcon({ off }) {
  return off ? (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 3l18 18" />
      <path d="M10.58 10.58a2 2 0 0 0 2.83 2.83" />
      <path d="M9.88 4.72A9.77 9.77 0 0 1 12 4.5c4.5 0 8.27 3 9.5 7.5a10.6 10.6 0 0 1-1.67 3.05M6.1 6.1C4.07 7.5 2.5 9.6 1.5 12c.7 1.7 1.78 3.18 3.13 4.34A9.77 9.77 0 0 0 12 19.5c1.04 0 2.04-.16 2.97-.46" />
    </svg>
  ) : (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1.5 12C2.73 7.5 6.5 4.5 12 4.5s9.27 3 10.5 7.5c-1.23 4.5-5 7.5-10.5 7.5s-9.27-3-10.5-7.5z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

export default function LoginPage() {
  const { login } = useAuth();
  const [form, setForm]       = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handle = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.username, form.password);
      toast.success("Welcome!");
    } catch (err) {
      toast.error(err.response?.data?.error || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-root">
      <div className="login-card">
        <div className="login-logo">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="48" height="48" rx="12" fill="#1a1a2e"/>
            {/* Invoice document body */}
            <rect x="11" y="7" width="26" height="34" rx="3" fill="#0f3460"/>
            <rect x="11" y="7" width="26" height="34" rx="3" stroke="#e94560" strokeWidth="1.2"/>
            {/* Folded corner */}
            <path d="M30 7 L37 14 L30 14 Z" fill="#1a1a2e" stroke="#e94560" strokeWidth="1"/>
            {/* Lines representing text/data */}
            <rect x="15" y="18" width="12" height="2" rx="1" fill="#e94560" opacity=".9"/>
            <rect x="15" y="23" width="18" height="1.5" rx=".75" fill="#cdd6f4" opacity=".5"/>
            <rect x="15" y="27" width="14" height="1.5" rx=".75" fill="#cdd6f4" opacity=".5"/>
            <rect x="15" y="31" width="16" height="1.5" rx=".75" fill="#cdd6f4" opacity=".5"/>
            {/* Rupee / total highlight */}
            <rect x="27" y="35" width="8" height="3" rx="1.5" fill="#e94560" opacity=".85"/>
          </svg>
          <span>Invoice Extractor</span>
        </div>

        <h1>Sign in</h1>

        <form onSubmit={handle}>
          <div className="field">
            <label>Username</label>
            <input
              type="text"
              autoComplete="username"
              value={form.username}
              onChange={e => setForm(p => ({ ...p, username: e.target.value }))}
              placeholder="Enter your username"
              required
            />
          </div>
          <div className="field">
            <label>Password</label>
            <div className="field-password-wrap">
              <input
                type={showPassword ? "text" : "password"}
                autoComplete="current-password"
                value={form.password}
                onChange={e => setForm(p => ({ ...p, password: e.target.value }))}
                placeholder="Enter your password"
                required
              />
              <button
                type="button"
                className="field-eye-btn"
                onClick={() => setShowPassword(s => !s)}
                title={showPassword ? "Hide password" : "Show password"}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                <EyeIcon off={showPassword} />
              </button>
            </div>
          </div>
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? "Signing in…" : "Sign in →"}
          </button>
        </form>
      </div>
    </div>
  );
}